import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconMail.module.css';

/**
 * A plain envelope, drawn as a stroke.
 *
 * This was the MailIcon defined inside TeamAmContactModal. It is here now
 * because the account manager cards put the same glyph on their "Get in touch"
 * button, and two copies of a path would drift.
 *
 * It strokes with `currentColor`, so it takes the colour of whatever it sits
 * in — the dark row in the dialog, and the white-on-black button on the cards —
 * without either caller passing a colour.
 *
 * The size comes from the caller's className. The default is 1em, so dropping
 * it into a line of text matches that text without any styling at all.
 */
const IconMail = props => {
  const { rootClassName, className } = props;

  return (
    <svg
      className={classNames(rootClassName || css.root, className)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m2 7 10 6 10-6" />
    </svg>
  );
};

IconMail.defaultProps = {
  rootClassName: null,
  className: null,
};

IconMail.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconMail;
